import { type Enum } from '@webapp/infrastructure/types/Enum'

export const BudgetIntervalTypes = {
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  YEARLY: 'yearly',
} as const

export type BudgetIntervalTypeEnum = Enum<typeof BudgetIntervalTypes>
